const Loading = () => <div className="spinner" />;

export default Loading;
